<template>
	<div class="container">
		<div class="content">
			<div class="list_container">
				<h3 class="title mb_20">{{ $t('rtr_activity-invoice.title') }}</h3>
				<div class="info_wrap">
					<div class="info mr_10">
						<p class="mb_10">{{ $t('rtr_activity.start') }}</p>
						<date-picker
							is-required
							v-model="startDate"
							:model-config="{ type: 'string' }"
							:locale="$store.state.common.locale"
						>
							<template v-slot="{ inputValue, inputEvents }">
								<label class="calendar_area">
									<input
										class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
										:value="inputValue"
										v-on="inputEvents"
									/>
								</label>
							</template>
						</date-picker>
					</div>
					<div class="info mr_10">
						<p class="mb_10">{{ $t('rtr_activity.end') }}</p>
						<date-picker
							is-required
							v-model="endDate"
							:model-config="{ type: 'string' }"
							:locale="$store.state.common.locale"
						>
							<template v-slot="{ inputValue, inputEvents }">
								<label class="calendar_area">
									<input
										class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
										:value="inputValue"
										v-on="inputEvents"
									/>
								</label>
							</template>
						</date-picker>
					</div>
					<!-- 자산선택 -->
					<div class="select_area">
						<select
							v-model="accountSeq"
							class="asset_area"
							@change="loadInvoiceList('pageInit')"
						>
							<option :value="null">
								{{ $t('input.placeholder.all_assets') }}
							</option>
							<option
								v-for="item in accounts"
								:key="item.seq"
								:value="item.seq"
							>
								{{ item.asset_title }}
							</option>
						</select>
						<span class="select_icon"></span>
					</div>
				</div>

				<div v-if="invoiceList.length > 0" class="list">
					<ul>
						<li
							class="list_item_box_wrap"
							v-for="item in invoiceList"
							:key="item.seq"
						>
							<div class="list_item_box">
								<span class="list_num">{{ item._no }}</span>
								<div class="list_item">
									<p>{{ $t('rtr_activity-invoice.target') }}</p>
									<p class="mb_10">{{ item.applicant_email_address }}</p>
									<p class="mb_0">
										{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
									</p>
								</div>
								<div class="list_item">
									<p>{{ $t('rtr_activity-invoice.request_asset') }}</p>
									<div class="asset_box">
										<span :class="'small ' + item.asset_code"></span>
										<p class="code mr_4">{{ item.asset_code }}</p>
										<p class="name">{{ item.asset_title }}</p>
									</div>
								</div>
								<div class="list_item">
									<p>{{ $t('rtr_activity-invoice.request_amount') }}</p>
									<p class="num">
										{{ item.net_amount }}
										<span class="fs_12">{{ item.asset_code }}</span>
									</p>
								</div>
								<div class="list_item">
									<p>{{ $t('rtr_activity-invoice.item') }}</p>
									<p>{{ item.title }}</p>
								</div>
								<!-- <div class="list_item">
								<p>{{ $t('rtr_activity-invoice.due_date') }}</p>
								<p>2022.11.05</p>
							</div> -->
							</div>
						</li>
					</ul>
					<pagination
						:totalCount="pageNavigation.total_count"
						:totalPage="pageNavigation.total_page"
						:curPage="pageNavigation.cur_page"
						:point="pageNavigation.point"
						:firstPage="pageNavigation.first_page"
						:lastPage="pageNavigation.last_page"
						@change="pageChangeHandler"
					></pagination>
				</div>
				<div class="list_none" v-else>
					<span class="ERRORGRAY"></span>
					<p>{{ $t('rtr_activity-invoice.empty') }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import pagination from '@/components/Pagination';
import { mapGetters } from 'vuex';
import { fetchInvoiceList } from '@/api/deposit';
import { commonError } from '@/common/dialog';

export default {
	name: 'Invoice',
	components: { pagination },
	data() {
		return {
			startDate: this.$dayjs(new Date()).add(-1, 'month').toDate(),
			endDate: new Date(),
			accountSeq: null,
			invoiceList: [],
			curPage: 1,
			listCount: 10,
			pageNavigation: {},
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
	},
	watch: {
		startDate() {
			this.loadInvoiceList('pageInit');
		},
		endDate() {
			this.loadInvoiceList('pageInit');
		},
	},
	created() {
		if (this.$route.query.accountSeq) {
			this.accountSeq = this.$route.query.accountSeq;
		}
		this.init();
	},
	methods: {
		init() {
			this.loadInvoiceList();
		},
		async loadInvoiceList(type) {
			if (type === 'pageInit') {
				this.curPage = 1;
			}
			const params = {
				account_seq: this.accountSeq,
				regdate_start: this.$dayjs(new Date(this.startDate))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.endDate).endOf('day').valueOf(),
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchInvoiceList(params).catch(
				commonError,
			);

			this.invoiceList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadInvoiceList();
		},
	},
};
</script>
